import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="border-t border-gray-100 py-10 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Waitlist CTA row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-8 pb-8 border-b border-gray-100">
          <div>
            <p className="text-sm font-bold text-foreground">Launching soon — be first in line.</p>
            <p className="text-xs text-muted mt-0.5">No spam, ever. Unsubscribe anytime.</p>
          </div>
          <Link
            href="/waitlist"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-xl font-bold text-sm hover:bg-primary/90 transition-all shadow-md hover:shadow-lg"
          >
            <span>Join the Waitlist</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </Link>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo + Copyright */}
          <div className="flex items-center gap-6">
            <AppLogo text="Summons" iconName="SparklesIcon" size={64} />
            <span className="text-sm text-muted">© 2026 Summons, Inc.</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm font-medium text-muted">
            <a href="/privacy-policy" className="hover:text-foreground transition-colors">Privacy</a>
            <a href="/terms-of-service" className="hover:text-foreground transition-colors">Terms</a>
            <a href="#" className="hover:text-foreground transition-colors">Support</a>
            <a href="https://app.getsummons.com" className="hover:text-foreground transition-colors">Web App</a>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-accent hover:text-accent transition-all text-muted">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-accent hover:text-accent transition-all text-muted">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center hover:border-accent hover:text-accent transition-all text-muted">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}